import { getReportInfo } from '@/utils/serviceInfo';
import RuntimeBaseReport from './RuntimeBaseReport';
import RuntimeAIPageBaseReport from './RuntimeAIPageBaseReport';

/**
 * 包含业务自定义ATTAID上报逻辑
 */
const systemConfig = {
  attaId: '03c00058181',
  attaToken: '5384471396',
};

const { id: attaId, token: attaToken } = getReportInfo()?.atta || {};

class RuntimeReport {
  constructor(ctorParams) {
    this.isAIPage = ctorParams.isAIPage;
    this.custom = attaId && attaToken;

    const systemReporterParams = {
      ...ctorParams,
      attaId: systemConfig.attaId,
      attaToken: systemConfig.attaToken,
      onlyPv: !!this.custom,
    };
    this.systemReporter = this.isAIPage
      ? new RuntimeAIPageBaseReport(systemReporterParams)
      : new RuntimeBaseReport(systemReporterParams);

    if (this.custom) {
      const customReporterParams = {
        ...ctorParams,
        attaId,
        attaToken,
        onlyPv: false,
      };
      this.customReporter = this.isAIPage
        ? new RuntimeAIPageBaseReport(customReporterParams)
        : new RuntimeBaseReport(customReporterParams);
    }

    this.normalReporter = this.custom ? this.customReporter : this.systemReporter;
  }

  pv() {
    this.systemReporter.pv();
    this.customReporter?.pv();

    return this;
  }

  pgOut() {
    this.systemReporter.pgOut();
    this.customReporter?.pgOut();

    return this;
  }

  destroy() {
    this.systemReporter.destroy();
    this.customReporter?.destroy();

    return this;
  }

  report(data) {
    this.normalReporter.report(data);
  }
}

export default RuntimeReport;
